import { useEffect, useState } from "react";
import type { VolunteerDashboardPayload } from "../types/volunteer-portal";
import { apiGet } from "./api";

interface State {
  data: VolunteerDashboardPayload | null;
  error: string | null;
  loading: boolean;
}

export function useVolunteerDashboard(): State {
  const [state, setState] = useState<State>({
    data: null,
    error: null,
    loading: true,
  });

  useEffect(() => {
    let cancelled = false;
    apiGet<VolunteerDashboardPayload>("/volunteer/dashboard")
      .then((data) => {
        if (!cancelled) setState({ data, error: null, loading: false });
      })
      .catch((err: Error) => {
        if (!cancelled) setState({ data: null, error: err.message, loading: false });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
